// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__RTW67","notes":"Notes_notes__27zvP","note":"Notes_note__3pQXg","markdown":"Notes_markdown__2AK8i"};